import React from "react";
import { Link } from "react-router-dom";
import PriceList from '../components/PriceList.js';
import ReactDOM from 'react-dom/client';



const showPage=()=>
    {
      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(<PriceList/>);
    }

function PublicNav() 
{
 
  
  return (
    <>
   <header id="header" class="">
  <div class="container d-flex align-items-center header-center justify-content-between"> <a href="index.html" class="logo"> <img src="../img/avt.png" alt="" class="img-fluid"/> </a>
    <div class="navbar navbar-expand-lg">
      <ul class="navbar-nav avt-top-menu">
        <li class="nav-item"> <a class="active" aria-current="page" href="index.html">Home</a> </li>
        <li class="nav-item"> <a href="#" onClick={showPage}>Pricing</a> </li>        
        <li class="nav-item"> <a href="#">Feature</a> </li>
        
      </ul>
    </div>
  {/*  <ul class="logo-right-list">
      <li><span   href="LoginPage" class="btn">Sign In</span></li>
    
    </ul>*/}
  </div>
</header>
                </>
  );
}


export default PublicNav;